import type { MouseEvent, ReactElement } from 'react';
import { Space, Tag, Typography } from 'antd';
import {
  E_INVOICE_REFERENCE_TYPE_LABEL,
  resolveOrderAccountingDocuments,
  type OrderAccountingDocumentSource,
} from './order-accounting-documents';

const { Text } = Typography;

export function OrderAccountingDocumentsCell({ order }: { order: OrderAccountingDocumentSource }): ReactElement {
  const documents = resolveOrderAccountingDocuments(order);
  if (documents.length === 0) return <Text type="secondary">—</Text>;

  return (
    <Space direction="vertical" size={2}>
      {documents.map((document) => {
        const referenceLabel = document.reference_type
          ? E_INVOICE_REFERENCE_TYPE_LABEL[document.reference_type]
          : undefined;
        return (
          <span key={`${document.type}-${document.doc_id}`}>
            <a
              href={document.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event: MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
            >
              {document.label}: <span style={{ whiteSpace: 'nowrap' }}>{document.code}</span>
            </a>
            {referenceLabel && <Tag style={{ marginInlineStart: 4, marginInlineEnd: 0 }}>{referenceLabel}</Tag>}
          </span>
        );
      })}
    </Space>
  );
}
